import { Search, Bell, Mail } from 'lucide-react';
import { Input } from '../ui/input';
import { UserMenu } from './UserMenu';

export function Header() {
  return (
    <header className="h-16 border-b bg-white flex items-center justify-between px-6">
      {/* Search */}
      <div className="flex-1 max-w-md">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
          <Input
            type="text"
            placeholder="Поиск"
            className="pl-10 bg-gray-50"
          />
        </div>
      </div>

      {/* Right side */}
      <div className="flex items-center gap-4">
        {/* User Menu */}
        <UserMenu />
      </div>
    </header>
  );
}
